import dayjs from "dayjs";

export const FinanceFilterStore = {
    namespaced: true,
    state() {
        return {
            display_contract: false,
            filter_type: "",
            filter_depense: "",
            filter_year: null,
            filter_month: "",
            filter_id: "",
            filter_prestataire: null,
            filter_contract: null,
            filter_site_tree: [],
        };
    },
    mutations: {
        setDisplayContract(state, value) {
            state.display_contract = value;
        },
        setFilterType(state, value) {
            state.filter_type = value;
        },
        setFilterId(state, value) {
            state.filter_id = value;
        },
        setFilterDepense(state, value) {
            state.filter_depense = value;
        },
        setFilterYear(state, value) {
            state.filter_year = value;
        },
        setFilterMonth(state, value) {
            state.filter_month = value;
        },
        setFilterSiteTree(state, value) {
            state.filter_site_tree = value;
        },
        setFilterPrestataire(state, value) {
            state.filter_prestataire = value;
        },
        setFilterContract(state, value) {
            state.filter_contract = value;
        },
    },
    getters: {
        getDisplayContract(state) {
            return state.display_contract;
        },
        getFilterType(state) {
            return state.filter_type;
        },
        getFilterId(state) {
            return state.filter_id;
        },
        getFilterDepense(state) {
            return state.filter_depense;
        },
        getFilterYear(state) {
            return state.filter_year;
        },
        getFilterMonth(state) {
            return state.filter_month;
        },
        getFilterSiteTree(state) {
            return state.filter_site_tree;
        },
        getFilterPrestataire(state) {
            return state.filter_prestataire;
        },
        getFilterContract(state) {
            return state.filter_contract;
        },
        getFilteredEntries(state, getters, rootState, rootGetters) {
            return rootGetters["finance/allEntries"].filter(function (entry) {
                let valid = true;
                if(state.display_contract === false && entry.type_depense === 'Dépense sous contrat') {
                    valid = false;
                }
                if(state.filter_type !== "" && entry.type_depense !== state.filter_type) {
                    valid = false;
                }
                if(state.filter_id !== "" && entry.id !== parseInt(state.filter_id)) {
                    valid = false;
                }
                if(state.filter_depense === 'previsionnel' && parseFloat(entry.previsionnel) === 0) {
                    valid = false;
                }

                if(state.filter_depense === 'realise' && parseFloat(entry.realise) === 0) {
                    valid = false;
                }
                if(state.filter_year !== null && dayjs(entry.date_gestion).year() !== parseInt(state.filter_year)) {
                    valid = false;
                }
                if(state.filter_month !== "" && dayjs(entry.date_gestion).month() !== parseInt(state.filter_month)) {
                    valid = false;
                }
                if(state.filter_site_tree.length > 0 && state.filter_site_tree.indexOf("") === -1 && state.filter_site_tree.indexOf(entry.site_id)) {
                    valid = false;
                }
                if(state.filter_prestataire !== null && state.filter_prestataire !== entry.prestataire_id) {
                    valid = false;
                }
                if(state.filter_contract !== null && state.filter_contract !== entry.contract) {
                    valid = false;
                }
                return valid;
            })
        }
    }
}